module.exports = __webpack_public_path__ + "assets/img/banner2.55e90166.png";